import { render, staticRenderFns } from "./TesoreriaView.vue?vue&type=template&id=528258ec&scoped=true"
import script from "./TesoreriaView.vue?vue&type=script&lang=js"
export * from "./TesoreriaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528258ec",
  null
  
)

export default component.exports